var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"4VlwTO-fdJ3QhWVMoT_sW"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { SENTRY_SECRET_KEY } from '@/helpers/variables';

Sentry.init({
  dsn: `https://${SENTRY_SECRET_KEY}@sentry.litres.io/101`,
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.05,
});
